<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4C13.3137 4 16 6.68629 16 10Z" stroke="#5E6678" style="stroke:#5E6678;stroke:color(display-p3 0.3686 0.4000 0.4706);stroke-opacity:1;" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2.67"/>
  </svg>
</template>

<script>
  export default {
    name: 'DotCircleIcon',
    props: {
      width: {
        type: Number,
        default: 20
      },
      height: {
        type: Number,
        default: 20
      }
    }
  }
</script>

<style scoped></style>